import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
async function initializeApiMode() {
  const localUrl = environment.servers[1].host;
  const externalUrl = environment.servers[2].host;
  
  // Гоняем два промиса: fetch и таймаут
  const result = await Promise.race([
  fetch(`${localUrl}/health`, { method: 'HEAD', mode: 'cors' })
    .then(res => res.ok)
    .catch(() => false),  // ← любая ошибка fetch становится false
  new Promise(resolve => setTimeout(() => resolve(false), 500))
]);
  
  environment.srv_mode = result ? 1 : 2;
  console.log(result ? '✅ Локальный бекенд' : '🌐 Внешний бекенд');
}

initializeApiMode().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
})
  